import { SOCIAL_TACTICS, Strategy as StrategyType } from '../utils'
import Styles from './CustomizeTable.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Heart } from 'blaze-ui/icons/24'
import { StrategyOrganicDropdown } from '../StrategyOrganicDropdown'
import { CountInput } from 'components/Wizards/CountInput/CountInput'
import cx from 'classnames'
import { useHover } from '@react-aria/interactions'
import { Trash2 } from 'blaze-ui/icons/20'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { uniq } from 'lodash'

export interface SocialRowProps {
  strategy: StrategyType
  onUpdate: (strategy: StrategyType) => void
  isDisabled?: boolean
}

export const SocialRow = ({ strategy, onUpdate, isDisabled }: SocialRowProps) => {
  const { hoverProps, isHovered } = useHover({})
  const crosspostContentsCount = strategy.crosspost_contents.find((content) => content.type === 'post')?.count || 0

  const handleUpdate = (value: number) => {
    let newTactics = strategy.tactics
    if (value === 0) {
      newTactics = newTactics.filter((tactic) => !SOCIAL_TACTICS.includes(tactic))
    } else if (value === 1 && !newTactics.some((tactic) => SOCIAL_TACTICS.includes(tactic))) {
      newTactics = uniq([...newTactics, ...SOCIAL_TACTICS])
    }

    onUpdate({
      ...strategy,
      crosspost_contents: [{ type: 'post', count: value }],
      tactics: newTactics,
    })
  }

  return (
    <div className={Styles.customizeContentRow} {...hoverProps}>
      <div className={Styles.customizeContentRowItem}>
        <Heart size={20} color="#FD4242" />
        <Text>Social media</Text>
      </div>
      <div className={cx(Styles.customizeContentRowItem, Styles.settingRowItem)}>
        <StrategyOrganicDropdown strategy={strategy} onUpdate={onUpdate} isDisabled={crosspostContentsCount === 0} />
      </div>
      <div className={cx(Styles.customizeContentRowItem, Styles.settingRowItem)}>
        <CountInput
          name="crosspost_contents"
          value={crosspostContentsCount || 0}
          onChange={handleUpdate}
          min={isDisabled ? 1 : 0}
          size="sm"
          buttonSize="sm"
          className={Styles.countInput}
        />
      </div>
      <div
        className={cx(Styles.customizeContentRowItem, Styles.actionRowItem, {
          [Styles.visible]: isHovered && crosspostContentsCount > 0,
        })}
      >
        <IconButton icon={Trash2} variant="tertiary" onPress={() => handleUpdate(0)} isDisabled={isDisabled} />
      </div>
    </div>
  )
}
